import { useRestQuery } from './tanstackQuery'
import { ApiQueryEndpoint } from '@/src/ApiQueryEndpoint'

interface UnreadOrder {
  order_id: number
  order_date: number
}

interface UnreadMessagesCountResponse {
  unread_count: number
  orders: UnreadOrder[]
}

const useUnreadMessages = ({
  isAuthenticated,
  enabled = true,
}: {
  isAuthenticated: boolean
  enabled?: boolean
}) => {
  const { data } = useRestQuery<UnreadMessagesCountResponse>({
    endpoint: ApiQueryEndpoint.COMMUNICATION.GET_UNREAD_COUNT.endpoint,
    enabled: isAuthenticated && enabled,
    refetchInterval: 60_000,
    staleTime: 30_000,
  })

  return {
    unreadCount: data?.unread_count ?? 0,
    unreadOrders: data?.orders ?? [],
  }
}

export default useUnreadMessages
